"use client";
import { useEffect, useState } from "react";
import { toast, ToastContainer } from "react-toastify";

import UserService from "@/services/api/UserService";

import { loginAfterAuthSuccess } from "@/helpers/auth";
import { useDispatch } from "react-redux";
import { useRouter } from "next/navigation";
import PasswordStepForm from "./components/PasswordStepForm";
import RegisterStepPhone from "@/components/common/drawer/AuthDrawer/components/Step/RegisterStepPhone";
import RegisterStepOtp from "@/components/common/drawer/AuthDrawer/components/Step/RegisterStepOtp";
import CommonImage from "@/components/common/image/CommonImage";
import { FaCirclePlay } from "react-icons/fa6";
import { closeDrawer } from "@/redux/slices/authDrawerSlice";
import TeacherService from "@/services/api/TeacherService";

const ForgetPassword = () => {
  const [step, setStep] = useState(1);
  const [phone, setPhone] = useState("");
  const [otp, setOtp] = useState("");
  const [timeLeft, setTimeLeft] = useState(120);
  const router = useRouter();

  const dispatch = useDispatch();

  useEffect(() => {
    if (step !== 2 || timeLeft <= 0) return;
    const timer = setInterval(() => {
      setTimeLeft((prev) => prev - 1);
    }, 1000);
    return () => clearInterval(timer);
  }, [timeLeft, step]);

  const handleSendOtp = async ({ phone }) => {
    try {
      await UserService.sendOtp({ phone_number: phone, type: "t_forget" });
      setPhone(phone);
      setOtp("");
      toast.success("ওটিপি পাঠানো হয়েছে");
      setTimeLeft(120);
      setStep(2);
    } catch (error) {
      const backendMessage = error?.response?.data?.message;
      if (backendMessage) {
        toast.error(backendMessage);
      } else {
        toast.error("ওটিপি পাঠাতে ব্যর্থ হয়েছে");
      }
    }
  };

  const handleResendOtp = async () => {
    try {
      await UserService.sendOtp({ phone_number: phone, type: "t_forget" });
      toast.success("ওটিপি আবার পাঠানো হয়েছে");
      setTimeLeft(120);
      setOtp("");
    } catch (error) {
      const backendMessage = error?.response?.data?.message;
      if (backendMessage) {
        toast.error(backendMessage);
      } else {
        toast.error("ওটিপি পাঠাতে ব্যর্থ হয়েছে");
      }
    }
  };

  const handleVerifyOtp = async () => {
    try {
      await UserService.verifyOtp({ phone_number: phone, otp_code: otp });
      toast.success("ওটিপি যাচাই সফল হয়েছে");
      setStep(3);
    } catch (error) {
      const backendMessage = error?.response?.data?.message;
      if (backendMessage) {
        toast.error(backendMessage);
      } else {
        toast.error("ওটিপি যাচাই ব্যর্থ হয়েছে");
      }
    }
  };

  const handleForgetPassword = async (values) => {
    try {
      const payload = { ...values, phone };
      await TeacherService.forgetPassword(payload);
      toast.success("পাসওয়ার্ড সফলভাবে পুনঃনির্ধারণ করা হয়েছে");
      router.push("/teacher/login");
    } catch (error) {
      // console.log("error", error);
      const backendMessage = error?.response?.data?.message;
      if (backendMessage) {
        toast.error(backendMessage);
      } else {
        toast.error(" ব্যর্থ হয়েছে");
      }
    }
  };

  return (
    <>
      <ToastContainer />

      <section className="login_section section_padding-48">
        <div className="container">
          <div
            className="login-section-card bg-pattern"
            style={{
              backgroundImage: "url('/images/home-page/program-pattern.avif')",
            }}
          >
            <div className="grid grid-cols-12 gap-6">
              <div className="lg:col-span-5 col-span-12">
                <div className="login-page-card">
                  <div className="login-registation-card !mt-0">
                    <div className="top-title">
                      <CommonImage
                        src={"/images/login/login-title.avif"}
                        className="top-icon"
                        alt="Icon"
                      />
                      <span className="text-[#2e4e8d] [.dark_&]:text-d-white font-medium text-sm">
                        পাসওয়ার্ড পুনঃনির্ধারণ করুন
                      </span>
                    </div>

                    <div className="login-form">
                      <>
                        {step === 1 && (
                          <RegisterStepPhone onSubmit={handleSendOtp} />
                        )}
                        {step === 2 && (
                          <RegisterStepOtp
                            otp={otp}
                            setOtp={setOtp}
                            timeLeft={timeLeft}
                            onResend={handleResendOtp}
                            onVerify={handleVerifyOtp}
                            onEditPhone={() => setStep(1)}
                          />
                        )}
                        {step === 3 && (
                          <PasswordStepForm onSubmit={handleForgetPassword} />
                        )}
                      </>
                    </div>
                  </div>
                </div>
              </div>

              <div className="lg:col-span-7 col-span-12">
                <div className="video-part">
                  <div className="login-video-thumbnail">
                    <CommonImage
                      src={"/images/login/login-video-thumbnail.avif"}
                      alt={"Image"}
                      className="login-thumbnail"
                    />
                    <div className="login-playbtn">
                      <button className="play-btn">
                        <FaCirclePlay className="play-icon" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ForgetPassword;
